import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { PropertyHttpService } from './property.http.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Property } from '../../models/property';

@Injectable()
export class PropertyStore {

  private propertySubject: BehaviorSubject<Property> = new BehaviorSubject(null);

  constructor(
    private propertyHttpService: PropertyHttpService,
    private flashMessagesService: FlashMessagesService
  ) { }

  /**
   * Returns an observable containing the current property.
   * Used in any case when data needs to be shown on a screen.
   *
   * @returns {Observable<T>}
   */
  get selectedProperty(): Observable<Property> {
    return this.propertySubject.asObservable();
  }

  /**
   * Retrieves property.  This method returns an observable
   * and should be used only in route resolvers.
   *
   * @param propertyId
   * @returns {Observable<Property>}
   */
  getProperty(propertyId: number): Observable<Property> {
    return this.propertyHttpService.get(propertyId)
      .catch((error: any) => {
        // Catch error here so resolver also displays error.
        this.flashMessagesService.error('MESSAGES.ERROR.GET_PROPERTY', `Error retrieving property: ${error}`);
        return Observable.throw(error);
      })
      .map((res: Property) => {
        this.propertySubject.next(res);
        return res;
      });
  }

  /**
   * Add property. This method returns an observable
   * of the saved property.
   *
   * @param newRec property to store
   * @returns {Observable<Property>}
   */
  addProperty(newRec: Property): Observable<Property> {
    return this.propertyHttpService.add(newRec)
      .catch(error => {
        this.flashMessagesService.error('MESSAGES.ERROR.ADD_PROPERTY', `Error adding property: ${error}`);
        return Observable.throw(error);
      })
      .map((res: Property) => {
        this.flashMessagesService.success('MESSAGES.SUCCESS.ADD_PROPERTY');
        this.propertySubject.next(res);
        return res;
      });
  }

  /**
   * Add vendor. This method returns an observable
   * of the saved vendor.
   *
   * @param newRec property to store
   * @returns {Observable<Property>}
   */
  addVendor(newRec: Property): Observable<Property> {
    return this.propertyHttpService.add(newRec)
      .catch(error => {
        this.flashMessagesService.error('MESSAGES.ERROR.ADD_VENDOR', `Error adding vendor: ${error}`);
        return Observable.throw(error);
      })
      .map((res: Property) => {
        this.flashMessagesService.success('MESSAGES.SUCCESS.ADD_VENDOR');
        this.propertySubject.next(res);
        return res;
      });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/property/property.store.ts